export type GetCustomTenantCatalogueApiResponse = /** status 200  */ {
  [key: string]: VehicleTypeResponseBody;
};

export type ModelFamilyResponseBody = {
  isCustom: boolean;
};

export type MakeResponseBody = {
  models: {
    [key: string]: ModelFamilyResponseBody;
  };
  isCustom: boolean;
};

export type VehicleTypeResponseBody = {
  makes: {
    [key: string]: MakeResponseBody;
  };
};
